import React from 'react';
import WriteOffsDataTable from "./WriteOffsDataTable";

const WriteOffs = () => {
    return (<WriteOffsDataTable/>);
};

export default WriteOffs;